module.exports = __webpack_public_path__ + "static/img/image-cxqf.43e300a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image-cxqf.jpg
// module id = 610f
// module chunks = 1